var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

const React = require('react');
const Icon = require('@infotech/uikit-icon').default;

function Svg(props) {
  const svgProps = Object.assign({}, props);
  const title = props.title;
  delete props.title;

  /* <svg {...svgProps} ><title>{title}<title>...</svg> */
  return React.createElement(
    'svg',
    _extends({ width: '16', height: '16', viewBox: '0 0 16 16', focusable: 'false' }, svgProps, { 'aria-labelledby': 'title' }),
    React.createElement(
      'title',
      { id: 'title' },
      title
    ),
    React.createElement('path', { d: 'M4 7V5a4 4 0 118 0v2h1a1 1 0 011 1v3c0 2.761-1.239 4-4 4H6c-2.761 0-4-1.239-4-4V8a1 1 0 011-1h1zm6 0V5a2 2 0 10-4 0v2h4z', fillRule: 'evenodd', role: 'presentation' })
  );
}

module.exports = function smallLock(props) {
  return React.createElement(Icon, _extends({ glyph: Svg }, props));
};